export const ToggleableComponentEmits = ["update:modelValue"];
